import React, { useContext, useEffect, useState } from 'react';

import { useTranslation } from "react-i18next";
import { DataGrid,GridToolbar } from '@mui/x-data-grid';

import {API, getCountries} from '../../services/api';
import jwtInterceoptor from '../../components/shared/jwtInterceptor';

import { date_formats } from '../../services/data';

import moment from 'moment';

import Swal from 'sweetalert2';
import { Link, useNavigate } from 'react-router-dom';
import GoBack from '../../components/goBack';
import { formatNumber } from '../../helpers/formater';
import {Button, LinearProgress, Stack} from '@mui/material';
import OrgContext from '../../organisation/OrgContext';
import { frFR, enUS } from '@mui/x-data-grid';
import useAuthHelper from "../../helpers/AuthHelper";

function OrganisationList(props) {
    const {onlyAdmins} = useAuthHelper();

    const [t, i18n] = useTranslation();

    const [organisations, setOrganisations] = useState([]);
    const {organisation, removeOrg} = useContext(OrgContext);

    const navigate = useNavigate();

    const [loadingData, setLoadingData] = useState(false);

    useEffect(()=>{
        onlyAdmins();

        const fetchOrganisations = async () => {
            setLoadingData(true);
            const response = await jwtInterceoptor.get("/data/organisations");
            console.log("res is: ", response)

            if(response.status >= 200 && response.status < 300){
                setOrganisations(response.data.data);
            }
            setLoadingData(false);
        };


        fetchOrganisations();

    }, []);

    const deleteItem = async (org) =>{
        Swal.fire({
            title: t('Are you sure?'),
            text: t("You won't be able to revert this!"),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: t('Yes, delete it!'),
            cancelButtonText: t("Cancel")
        }).then(async (result) => {
            if (result.isConfirmed) {
                const response = await jwtInterceoptor.delete(`/data/organisations/${org.id}`);

                if(response.status === 200){
                    if(response.data.status == true){
                        let orgs = organisations.filter(el => el.id != org.id);

                        setOrganisations(orgs);

                        if(org.id == organisation?.id){
                            try {
                                removeOrg();
                            } catch (error) {
                                
                            }
                            
                            window.location.reload();
                            return;
                        }


                        Swal.fire(
                            t('Deleted!'),
                            t('Your record has been deleted.'),
                            'success'
                        )

                        return;
                    }
                    
                }

                Swal.fire({
                    icon: 'warning',
                    title: '',
                    text: t('Something went wrong!, try again'),
                });
                
            }
        })
    }


    const columns = [
        { field: 'id', headerName: t("ID ORGANISATION"), width: 150,
            valueGetter: (params) =>
            `${formatNumber(params.row.id) || ''}`,
        },
        { field: 'name', headerName: t("NOM DE L'ORGANISATION"), width: 210, },
        { field: 'activity', headerName: t("ACTIVITÉ"),
            valueGetter: (params) =>
            params.row.activity.id!==33?`${params.row.activity.name || ''}`:`${params.row.autre|| ''}`,
            width: 210,
        },
        { field: 'country', 
            headerName: t("ADRESSE DE L'ENTREPRISE"),
            valueGetter: (params) =>
                `${params.row.country.name || ''}`,
                width: 200,
        },
        { field: 'city', headerName: t("VILLE"), width: 100 },
        { field: 'currency', headerName: t("DEVISE DE BASE"),
        valueGetter: (params) =>
        `${params.row.currency.code || ''}`,
        
        width: 70 },
        {
            field: 'action',
            headerName: t("ACTIONS"),
            width: 180,
            sortable: false,
            disableClickEventBubbling: true,
            
            renderCell: (params) => {
                const onDelete = (e) => {
                  const currentRow = params.row;
                  return deleteItem(currentRow);
                };

                const onEdit = (e) => {
                    const currentRow = params.row;

                    navigate("/organisation/edit", {state: {org: currentRow}});
                  };
                
                return (
                    <div className="btn-list">
                        <button onClick={onEdit} id="bDel" type="button" className="btn  btn-sm btn-primary">
                            <span className="fe fe-edit"> </span>
                        </button>
                        <button onClick={onDelete} id="bDel" type="button" className="btn  btn-sm btn-danger">
                            <span className="fe fe-trash-2"> </span>
                        </button>
                    </div>
                );
            },
          }
       
    ];


    return (
        <>
            {/* <GoBack route='/organisations' /> */}
            <div className="row">
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title">{t("Profil de l'organisation")}</h3>
                        </div>
                        <div className="card-body">
                            <Link id="table2-new-row-button" to="/organisation_profile" className="btn btn-primary mb-4"> {t("Add New")}</Link>
                            <div className="table-responsive">
                                <div style={{ height: 600, width: '100%' }}>
                                    <DataGrid

                                        rows={organisations}
                                        columns={columns}
                                        pagination={false}
                                        checkboxSelection
                                        localeText={
                                            i18n.language == "fr" ?
                                                frFR.components.MuiDataGrid.defaultProps.localeText :
                                                enUS.components.MuiDataGrid.defaultProps.localeText
                                        }
                                        slotProps={{
                                            toolbar: {
                                                printOptions: { disableToolbarButton: true },
                                                csvOptions: { disableToolbarButton: true },
                                            }}
                                        }
                                        slots={{
                                            loadingOverlay: LinearProgress,
                                            toolbar: GridToolbar
                                        }}
                                        loading={loadingData}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default OrganisationList;